// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__pTuZ2","rootCenter":"LoadMoreObserver_rootCenter__aymux","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__30RTQ"};